import { Link } from "react-router-dom";

export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <circle cx="32" cy="32" r="29" fill="#07030c" stroke="#a855f7" strokeWidth="2.5" />
    <path d="M18 46V24l14 14 14-14v22" fill="none" stroke="#f3eefc" strokeWidth="3.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M32 9l3.5 4.5L32 18l-3.5-4.5z" fill="#a855f7" />
  </svg>
);

export const Logo = () => (
  <Link to="/" data-testid="nav-logo-link" className="group flex items-center gap-3">
    <span className="transition-transform duration-700 group-hover:rotate-[360deg]">
      <LogoMark />
    </span>
    <span className="font-display text-lg leading-none tracking-tight">
      Maison Pierre <span className="italic text-[#d8b4fe]">&amp; Co.</span>
    </span>
  </Link>
);
